import { render, staticRenderFns } from "./WinLose.vue?vue&type=template&id=6ae89054&scoped=true"
import script from "./WinLose.vue?vue&type=script&lang=ts"
export * from "./WinLose.vue?vue&type=script&lang=ts"
import style0 from "./WinLose.vue?vue&type=style&index=0&id=6ae89054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae89054",
  null
  
)

export default component.exports